import { render, staticRenderFns } from "./CreateDTE.vue?vue&type=template&id=3b8ac00f&scoped=true&"
import script from "./CreateDTE.vue?vue&type=script&lang=js&"
export * from "./CreateDTE.vue?vue&type=script&lang=js&"
import style0 from "./CreateDTE.vue?vue&type=style&index=0&id=3b8ac00f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8ac00f",
  null
  
)

export default component.exports